import get from 'lodash/get';
import set from 'lodash/set';
import { arrayIt } from '@/utils';

export const backup = {
	data() {
		return {
			/**
			 * Stores our backed-up props.
			 *
			 * @type {Object}
			 */
			backup: {},
		};
	},
	methods: {
		/**
		 * Takes a list of of props and toggles them to/from backup.
		 *
		 * @since  2.0.0
		 *
		 * @param  {boolean} restore Whether to restore (or backup) the props.
		 * @param  {Array|string|Object} props A prop name, array of names, or object (with key/value, value being the "empty" result)
		 *
		 * @returns {void}
		 */
		toggleBackup(restore, props) {
			this[restore ? 'restoreFromBackup' : 'backupProps'](props);
		},
		/**
		 * Takes a list of of props and moves them to backup.
		 *
		 * @since  2.0.0
		 *
		 * @param  {Array|string|Object} props A prop name, array of names, or object (with key/value, value being the "empty" result)
		 *
		 * @returns {void}
		 */
		backupProps(props) {
			arrayIt(props).forEach((key) => {
				const resetVal = get(key, 'value', '');
				key = get(key, 'key', key);
				this.backup[key] = this.$get(key);
				set(this, key, resetVal);
			});
		},
		/**
		 * Takes a list of of props and restores them from backup.
		 *
		 * @since  2.0.0
		 *
		 * @param  {Array|string|Object} props A prop name, array of names, or object (with key/value, value being the "empty" result)
		 *
		 * @returns {void}
		 */
		restoreFromBackup(props) {
			arrayIt(props).forEach((key) => {
				key = get(key, 'key', key);
				if (key in this.backup) {
					set(this, key, this.backup[key]);
					delete this.backup[key];
				}
			});
		},
	},
};
